"use strict";
// Can everything just always rotate?
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadMinigolfRegions = exports.allMinigolfRegions = exports.MinigolfExitFlags = void 0;
var deepFreeze_1 = require("@engine/deepFreeze");
var onceOnly_1 = require("@lib/onceOnly");
exports.MinigolfExitFlags = {
    None: 0,
    North: 1,
    East: 2,
    South: 4,
    West: 8,
};
deepFreeze_1.deepFreeze(exports.MinigolfExitFlags);
exports.allMinigolfRegions = [];
var loadMinigolfRegions = function (protoSections) {
    onceOnly_1.ensureCalledOnlyOnce('loadMinigolfRegions');
    for (var i = 0; i < protoSections.length; i++) {
        var protoSection = protoSections[i];
        var regionName = protoSection.name;
        var canRotate = true;
        var rotationAmount = 3;
        var exitFlags = exports.MinigolfExitFlags.None;
        var isStart = false;
        var isEnd = false;
        var isDifficultySelect = false;
        var isDeadEnd = false;
        var isOutside = false;
        var isTest = false;
        var isWinLevel = false;
        var enemyDifficulty = 0;
        var parts = regionName.split('-');
        if (parts.length <= 1) {
            console.log('Invalid minigolf region name', regionName);
            continue;
        }
        var type = parts[0];
        var exits = parts[1];
        if (type.startsWith('x')) {
            console.log('skipping minigolf region name', regionName);
            continue;
        }
        var lastPart = parts[parts.length - 1];
        if (lastPart.startsWith('d')) {
            // Get difficulty level
            var d = parseInt(lastPart.substring(1));
            if (!Number.isNaN(d)) {
                enemyDifficulty = d;
            }
        }
        // Add flags
        if (type === 'start') {
            isStart = true;
            rotationAmount = 1;
        }
        if (type === 'dead') {
            isDeadEnd = true;
        }
        if (type === 'end') {
            isEnd = true;
        }
        if (type === 'select') {
            isDifficultySelect = true;
        }
        if (type === 'out') {
            isOutside = true;
        }
        if (type === 'test') {
            isTest = true;
        }
        if (type === 'victory') {
            isWinLevel = true;
        }
        // Add our directions
        if (exits.includes('n')) {
            exitFlags |= exports.MinigolfExitFlags.North;
        }
        if (exits.includes('e')) {
            exitFlags |= exports.MinigolfExitFlags.East;
        }
        if (exits.includes('s')) {
            exitFlags |= exports.MinigolfExitFlags.South;
        }
        if (exits.includes('w')) {
            exitFlags |= exports.MinigolfExitFlags.West;
        }
        exports.allMinigolfRegions.push({
            name: regionName,
            canRotate: canRotate,
            exitFlags: exitFlags,
            protoSection: protoSection,
            isStart: isStart,
            isEnd: isEnd,
            isDifficultySelect: isDifficultySelect,
            isDeadEnd: isDeadEnd,
            isOutside: isOutside,
            isTest: isTest,
            isWinLevel: isWinLevel,
            enemyDifficulty: enemyDifficulty,
        });
        if (canRotate) {
            for (var idxRotation = 0; idxRotation < rotationAmount; idxRotation++) {
                // Rotate our exit flags clockwise
                var newExitFlags = 0;
                if (exitFlags & exports.MinigolfExitFlags.North) {
                    newExitFlags |= exports.MinigolfExitFlags.East;
                }
                if (exitFlags & exports.MinigolfExitFlags.East) {
                    newExitFlags |= exports.MinigolfExitFlags.South;
                }
                if (exitFlags & exports.MinigolfExitFlags.South) {
                    newExitFlags |= exports.MinigolfExitFlags.West;
                }
                if (exitFlags & exports.MinigolfExitFlags.West) {
                    newExitFlags |= exports.MinigolfExitFlags.North;
                }
                exitFlags = newExitFlags;
                protoSection = cloneAndRotateProtoSectionClockwise(protoSection, idxRotation);
                exports.allMinigolfRegions.push({
                    name: regionName + '-rot' + idxRotation,
                    canRotate: canRotate,
                    exitFlags: exitFlags,
                    protoSection: protoSection,
                    isStart: isStart,
                    isEnd: isEnd,
                    isDifficultySelect: isDifficultySelect,
                    isDeadEnd: isDeadEnd,
                    isOutside: isOutside,
                    isTest: isTest,
                    isWinLevel: isWinLevel,
                    enemyDifficulty: enemyDifficulty,
                });
            }
        }
    }
};
exports.loadMinigolfRegions = loadMinigolfRegions;
function cloneAndRotateProtoSectionClockwise(protoSection, idxRotation) {
    var newProtoSection = {
        name: protoSection.name + '-rot' + idxRotation,
        tileWidth: protoSection.tileHeight,
        tileHeight: protoSection.tileWidth,
        tiles: [],
    };
    for (var j = 0; j < protoSection.tileHeight; j++) {
        for (var i = 0; i < protoSection.tileWidth; i++) {
            // TODO: is this the correct rotation? looks good!
            var fromx = j;
            var fromy = protoSection.tileWidth - i - 1;
            var tile = protoSection.tiles[fromy * protoSection.tileWidth + fromx];
            var newTile = {
                // ox: j,
                // oy: protoSection.tileWidth - i - 1,
                // tx: j,
                // ty: protoSection.tileWidth - i - 1,
                ox: i,
                oy: j,
                tx: 0,
                ty: 0,
                tileIdx: tile.tileIdx,
                tileIdxUp: tile.tileIdxUp,
                color: tile.color,
                rotation: tile.rotation + 1,
                horizSpanCount: 0,
                vertSpanCount: 0,
            };
            newProtoSection.tiles.push(newTile);
        }
    }
    return newProtoSection;
}
